import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import DeleteAccountService from '../../service/deleteAccount/deleteAccount';
import UserService from '../../service/User';
import PageTop from '../components/pageTop/PageTop';
import Footer from '../components/footer/Footer';
import Menu from '../components/menu/Menu';

interface UserInfo {
  branchcode: number;
  department: string;
  email: string;
  login_type: string;
  name: string;
  notification: string;
  position: string;
  regdate: string;
  state: string;
  tel: string;
  userid: string;
  usertype: string;
  img: string;
  marketing: string;
  info_consent: string;
}

const DeleteAccountPage = () => {
  const [data, setData] = useState<UserInfo>();
  const [agreeToCaution, setagreeToCaution] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [isCirtificationModalOpen, setIsCirtificationModalOpen] =
    useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [code, setCode] = useState('');
  const [email, setEmail] = useState('');
  const [createdAt, setCreatedAt] = useState('');
  const [isSended, setIsSended] = useState(false);
  const isConfirmActive =
    selectedReason !== '' &&
    agreeToCaution &&
    (selectedReason === '기타' ? customReason !== '' : true);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const reasons = [
    '서비스 사용을 잘 안하게 돼요',
    '서비스 사용이 어려워요',
    '다른 유사 서비스를 이용 중이에요',
    '서비스 이용 금액이 비싼 것 같아요',
    '혜택(무료 체험, 쿠폰)이 너무 적어요',
    '개인정보를 삭제하고 싶어요',
    '다른 계정이 있어요',
    '기타',
  ];

  const { setUser } = useUser();
  const navigate = useNavigate();
  const getInfo = async () => {
    try {
      const res = await UserService.userInfo();
      setData(res.data);
      setUser(res.data);
    } catch (error) {
      console.error('userInfo 함수에서 에러 발생:', error);
    }
  };

  const sendCode = async () => {
    try {
      const res = await DeleteAccountService.sendCode(phoneNumber);
      setIsSended(true);
    } catch (error) {
      console.error('인증번호 전송 중 에러 발생:', error);
    }
  };

  const verifyCode = async () => {
    try {
      const res = await DeleteAccountService.verifyCode(phoneNumber, code);
      if (res.status === 'success') {
        deleteAccount();
      }
    } catch (error) {
      console.error('인증번호 확인 중 에러 발생:', error);
    }
  };

  const deleteAccount = async () => {
    try {
      if (phoneNumber && selectedReason) {
        const res = await DeleteAccountService.withdrawal(
          phoneNumber,
          selectedReason,
          selectedReason === '기타' ? customReason : '',
        );
        console.log(res.data);
        setEmail(res?.data?.email);
        setCreatedAt(res?.data?.created_at);
      }
      setIsSuccessModalOpen(true);
    } catch (error) {
      console.error('탈퇴 요청 중 에러 발생:', error);
    }
  };
  useEffect(() => {
    getInfo();
  }, []);

  return (
    <>
      <PageTop
        text="회원탈퇴"
        setOpenMenu={setOpenMenu}
        isMenu={false}
        isSearch={false}
      />
      <Container>
        <Box>
          <Header>
            <span>{data?.name}님</span>
            <BlueText>정말 떠나시겠어요?</BlueText>
          </Header>
          <GrayBox>
            <Line>
              <Dot src="assets/images/icon/dot.svg" />
              <span>
                탈퇴 시 사용자의 모든 정보가 사라지고 복구가 불가능합니다.
              </span>
            </Line>
            <Line>
              <Dot src="assets/images/icon/dot.svg" />
              <span>
                탈퇴 요청 접수 후, 영업일 기준 7일 이내에 탈퇴 완료 처리를
                해드립니다.
              </span>
            </Line>
            <Line>
              <Dot src="assets/images/icon/dot.svg" />
              <BoldText>
                탈퇴 후 <RedText>재가입은 1달 이후</RedText>에 가능합니다.
              </BoldText>
            </Line>
            <Line>
              <Dot src="assets/images/icon/dot.svg" />
              <span>
                탈퇴 고객의 개인정보는 회원에게 개인정보 보관기간에 대해 별도의
                동의를 얻은 경우, 또는 관련 법령에서 정한 정보보관 의무 기간
                동안 안전하게 보관합니다.
              </span>
            </Line>
            <Line>
              <Dot src="assets/images/icon/dot.svg" />
              <BoldText>
                땅집고옥션 유료 멤버십을 결제하셨다면{' '}
                <RedText>꼭! 잔여기간에 대한 환불처리를 먼저 완료</RedText>한
                후에 탈퇴를 접수 바랍니다. 탈퇴 후의 환불 접수는 불가합니다.
              </BoldText>
            </Line>
            <Line>
              <Dot src="assets/images/icon/dot.svg" />
              <span>탈퇴 최종 확인은 휴대폰 번호 인증으로 진행됩니다.</span>
            </Line>
          </GrayBox>
          <CheckBox>
            <CheckImg
              onClick={() => setagreeToCaution(!agreeToCaution)}
              src={
                agreeToCaution
                  ? 'assets/images/check/signUpcheckOn.svg'
                  : 'assets/images/check/deleteAccountcheckOff.svg'
              }
              alt=""
            />
            <span>(필수) 유의사항을 확인하였으며 동의합니다.</span>
          </CheckBox>
        </Box>
        <Box>
          <Header>
            <span>
              <BlueText>떠나시는 이유</BlueText>가 궁금해요.
            </span>
            <SmallGrayText>
              더 발전하는 서비스가 될 수 있도록 노력하겠습니다.
            </SmallGrayText>
          </Header>
          <GrayBox>
            {reasons.map((reason, index) => (
              <div key={index}>
                <CheckBox onClick={() => setSelectedReason(reason)}>
                  <CheckImg
                    src={
                      selectedReason === reason
                        ? 'assets/images/check/signUpcheckOn.svg'
                        : 'assets/images/check/deleteAccountcheckOff.svg'
                    }
                    alt=""
                  />
                  <span>{reason}</span>
                </CheckBox>
                {reason === '기타' && selectedReason === '기타' && (
                  <CustomInput
                    value={customReason}
                    onChange={(e) => setCustomReason(e.target.value)}
                    placeholder="탈퇴 사유를 입력해주세요"
                  />
                )}
              </div>
            ))}
          </GrayBox>

          <ButtonBox>
            <CancelButton onClick={() => navigate(-1)}>취소</CancelButton>
            <ConfirmButton
              isActive={isConfirmActive}
              onClick={() => {
                if (isConfirmActive) {
                  setIsCirtificationModalOpen(true);
                }
              }}
            >
              탈퇴하기
            </ConfirmButton>
          </ButtonBox>
        </Box>
      </Container>
      <Footer />
      {isCirtificationModalOpen && (
        <ModalOverlay>
          <ModalBox>
            <ModalTitle>휴대폰 번호 인증</ModalTitle>
            <ModalDescription>
              안전한 회원탈퇴를 위해 휴대폰 번호를
              <br />
              입력해 주세요.
            </ModalDescription>
            <PhoneBox>
              <span
                style={{ fontSize: '12px', color: '#616161', fontWeight: 500 }}
              >
                휴대폰 번호
              </span>
              <GetCodeBox>
                <PhoneNumberInput
                  type="text"
                  placeholder="010 0000 0000"
                  value={phoneNumber}
                  onChange={(e) =>
                    setPhoneNumber(
                      e.target.value.replace(/\D/g, '').slice(0, 11),
                    )
                  }
                />
                <GetCodeButton
                  onClick={() => {
                    {
                      phoneNumber.length === 11 && sendCode();
                    }
                  }}
                >
                  {isSended ? '재전송' : '인증번호 받기'}
                </GetCodeButton>
              </GetCodeBox>
            </PhoneBox>
            {isSended && (
              <PhoneBox>
                <span
                  style={{
                    fontSize: '12px',
                    color: '#616161',
                    fontWeight: 500,
                  }}
                >
                  인증번호
                </span>
                <GetCodeBox>
                  <CodeInput
                    type="text"
                    placeholder="인증번호 6자리를 입력해주세요"
                    value={code}
                    onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                  />
                </GetCodeBox>
              </PhoneBox>
            )}
            <ModalButtonRow>
              <CancelButton onClick={() => setIsCirtificationModalOpen(false)}>
                취소
              </CancelButton>
              <ModalConfirmButton
                disabled={!(phoneNumber.length === 11 && code.length === 6)}
                onClick={() => {
                  verifyCode();
                }}
              >
                탈퇴하기
              </ModalConfirmButton>
            </ModalButtonRow>
          </ModalBox>
        </ModalOverlay>
      )}
      {isSuccessModalOpen && (
        <ModalOverlay>
          <ModalBox>
            <img
              src="/assets/images/check/blue_check_48.svg"
              alt="성공"
              width="48px"
              height="48px"
              style={{ marginBottom: '12px' }}
            />
            <ModalTitle>회원탈퇴 신청완료</ModalTitle>
            <ModalDescription>
              그동안 땅집고옥션을 이용해 주셔서 감사합니다.
              <br />
              더욱 노력하고 발전하는 땅집고옥션이 되겠습니다.
            </ModalDescription>
            <InfoBox>
              <InfoRow>
                <Label>탈퇴 신청 아이디</Label>
                <Value>{email}</Value>
              </InfoRow>
              <InfoRow>
                <Label>탈퇴 신청 일자</Label>
                <Value>{createdAt.replace(/-/g, '.')}</Value>
              </InfoRow>
            </InfoBox>
            <ModalButtonRow>
              <DeleteConfirmButton
                onClick={() => {
                  setIsSuccessModalOpen(false);
                  navigate('/');
                }}
              >
                확인
              </DeleteConfirmButton>
            </ModalButtonRow>
          </ModalBox>
        </ModalOverlay>
      )}
      {openMenu && <Menu page="/mypage/payment" setOpenMenu={setOpenMenu} />}
    </>
  );
};

export default DeleteAccountPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 32px 16px 120px;
  gap: 40px;
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const Header = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #222222;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const GrayBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  background-color: rgba(112, 115, 124, 0.05);
  font-size: 16px;
`;

const Line = styled.span`
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #616161;
`;

const Dot = styled.img`
  width: 3px;
  height: 20px;
`;

const RedText = styled.span`
  color: #f45551;
`;

const BlueText = styled.span`
  color: #008aff;
`;

const BoldText = styled.span`
  font-weight: 700;
`;

const CheckBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #222222;
  align-items: center;

  line-height: 145%;
`;

const CheckImg = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

const SmallGrayText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const ButtonBox = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px 16px 36px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  z-index: 999;
`;

const CancelButton = styled.button`
  padding: 14px 28px;
  width: 50%;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #989ba2;
  border: 1px solid #e1e2e4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #fff;
`;

const ConfirmButton = styled.button<{ isActive: boolean }>`
  padding: 14px 28px;
  width: 50%;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};

  background-color: ${({ isActive }) => (isActive ? '#008aff' : '#f7f7f8')};
  color: ${({ isActive }) => (isActive ? '#ffffff' : 'rgba(55, 56, 60, 0.16)')};
  border: 1px solid transparent;
`;

const CustomInput = styled.textarea`
  margin-top: 16px;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #008aff;
  border-radius: 8px;
  font-size: 14px;
  resize: none;
  min-height: 80px;
  background-color: #fff;
  color: #222222;
  placeholder {
    color: rgba(55, 56, 60, 0.61);
  }
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.52);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  padding: 0px 16px;
`;

const ModalBox = styled.div`
  background: white;
  border-radius: 16px;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ModalTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  text-align: center;
`;

const ModalDescription = styled.p`
  font-size: 14px;
  color: #616161;
  font-weight: 500;
  text-align: center;
  margin-bottom: 24px;
`;

const PhoneNumberInput = styled.input`
  width: 50%;
  font-size: 14px;
  border: none;
  font-size: 16px;
  background-color: transparent;
  &::placeholder {
    color: rgba(55, 56, 60, 0.28);
  }
`;

const CodeInput = styled.input`
  width: 100%;
  font-size: 14px;
  border: none;
  font-size: 16px;
  background-color: transparent;
  &::placeholder {
    color: rgba(55, 56, 60, 0.28);
  }
`;

const GetCodeButton = styled.button`
  padding: 6px 12px;
  height: 32px;
  background-color: rgba(112, 115, 124, 0.16);
  color: #222222;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

const PhoneBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 24px;
  padding: 12px 12px 12px 16px;
  background-color: #f7f8fc;
  border-radius: 16px;
`;

const GetCodeBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ModalButtonRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const ModalConfirmButton = styled.button<{ disabled?: boolean }>`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 28px;
  background-color: ${({ disabled }) => (disabled ? '#f7f7f8' : '#008aff')};
  color: ${({ disabled }) => (disabled ? 'rgba(55, 56, 60, 0.16)' : '#ffffff')};
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

const InfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f7f8fc;
  border-radius: 16px;
`;

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;

const Value = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #222;
`;

const DeleteConfirmButton = styled.button`
  width: 100%;
  padding: 14px 28px;
  background-color: #008aff;
  color: #ffffff;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
`;
